import { cancellableRequest } from './request';

const LoyaltyService = {
    getMyLoyalty: () => cancellableRequest({ method: 'get', url: '/loyalty/me' }),
    acceptAgb: () => cancellableRequest({ method: 'post', url: '/loyalty/consent' }),
};

export { LoyaltyService };
